<!--
출고운임 과금 — 래퍼 컴포넌트
------------------------------------
환율 입력 + 과금 진행상황을 인라인으로 표시한다.
-->
<template>
<div class="">
    <charge
        ref="charge"
        :csrfToken="csrfToken"
        :region-id="regionId"
        :shipout-id="shipoutId"
        :shipout-date="shipoutDate"
        :region-currency="regionCurrency"
        :active-progress-id="activeProgressId"
        :active-progress-status="activeProgressStatus"
        :has-uncharged="hasUncharged"
        :has-completed-billings="hasCompletedBillings"
        :uncharged-user-count="unchargedUserCount"
        :uncharged-house-count="unchargedHouseCount"
    ></charge>
</div>
</template>

<script>
    export default {
        components: {
            'charge': require('./charge.vue').default,
        },
        props: {
            // csrf-token
            csrfToken: String,
            /**
             * 지역id
             */
            regionId: {
                type: Number,
                default: null,
            },
            /**
             * 출고id
             */
            shipoutId: {
                type: Number,
                default: null,
            },
            /**
             * 출고일
             */
            shipoutDate: {
                type: String,
                default: null,
            },
            /**
             * 지역통화
             */
            regionCurrency: {
                type: String,
                default: null,
            },
            /**
             * 진행중인 progress ID (PENDING/RUNNING만 — 재방문 시 폴링 복구용)
             */
            activeProgressId: {
                type: Number,
                default: null,
            },
            /**
             * 진행중 progress 상태값 (1=PENDING, 2=RUNNING)
             */
            activeProgressStatus: {
                type: Number,
                default: null,
            },
            /**
             * 미과금 하우스 존재 여부
             */
            hasUncharged: {
                type: Boolean,
                default: true,
            },
            /**
             * 과금 완료 billing이 존재하는지 (레거시 데이터 분기용)
             */
            hasCompletedBillings: {
                type: Boolean,
                default: false,
            },
            /**
             * [TASK-037] 미과금 회원사 수
             */
            unchargedUserCount: {
                type: Number,
                default: 0,
            },
            /**
             * [TASK-037] 미과금 하우스 수
             */
            unchargedHouseCount: {
                type: Number,
                default: 0,
            },
        },
        data: function () {
            return {
            };
        },
        computed: {
        },
        methods: {
        },
    }
</script>

<style lang="scss" scoped>
</style>
